export const CHECK_EXCEPTION_DETAIL_CONTAINER_TAG_NAME = 'check-exception-detail-container';
